import React, { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { formatPrice } from "@/lib/currency";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) api.get("/orders").then((r) => setOrders(r.data));
  }, [user]);

  if (loading) return <div className="text-center py-32 overline">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div data-testid="account-page" className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20">
      <div className="flex justify-between items-end mb-16">
        <div>
          <div className="overline">Account</div>
          <h1 className="serif text-5xl mt-3">Hello, {user.name}.</h1>
          <p className="text-[#5A5A5A] mt-2">{user.email} · {user.role}</p>
        </div>
        <button data-testid="logout-button" onClick={logout} className="btn-ghost">Sign out</button>
      </div>

      <div className="grid lg:grid-cols-3 gap-6 mb-16">
        <Link to="/wishlist" className="border border-[#E5E5DF] p-6 hover:border-[#0A0A0A] transition-colors">
          <div className="overline">Wishlist</div>
          <div className="serif text-2xl mt-2">Saved pieces →</div>
        </Link>
        <Link to="/custom-bag" className="border border-[#E5E5DF] p-6 hover:border-[#0A0A0A] transition-colors">
          <div className="overline">Bespoke</div>
          <div className="serif text-2xl mt-2">Design a bag →</div>
        </Link>
        {user.role === "admin" && (
          <Link to="/admin" data-testid="goto-admin" className="border border-[#C5A059] p-6 bg-[#C5A059]/5 hover:bg-[#C5A059]/10">
            <div className="overline text-[#C5A059]">Admin</div>
            <div className="serif text-2xl mt-2">Dashboard →</div>
          </Link>
        )}
      </div>

      <div>
        <h2 className="serif text-3xl">Your orders</h2>
        <div className="mt-6 space-y-3">
          {orders.length === 0 && <p className="text-[#5A5A5A]">No orders yet.</p>}
          {orders.map((o) => (
            <div key={o.id} className="border border-[#E5E5DF] p-5 flex justify-between items-center">
              <div>
                <div className="overline">Order · {o.id.slice(0, 8)}</div>
                <div className="serif text-xl mt-1">{o.items.length} item{o.items.length > 1 ? "s" : ""} · {formatPrice(o.total)}</div>
                <div className="text-xs text-[#5A5A5A] mt-1">Status: {o.status}</div>
              </div>
              <div className="text-xs text-[#5A5A5A]">{new Date(o.created_at).toLocaleDateString()}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
